import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import ContratosLogged from '../../../components/auth/contratos'

function ContratosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Licitação" />
                <HeaderLogged />
                <Container>
                   <ContratosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ContratosLoggedScreen;